import React, { Component } from 'react';
import Firebase from 'firebase';
import DatePicker from 'react-datepicker';

class renderComponents extends Component {
    constructor() {
        super();
        this.state = {
            value: ""
        }
    }

    render() {
        switch (this.props.element.element_id) {
            case 'RADIOBUTTON':
                return (
                    <div className="form-group row" style={{ textAlign: "justify" }}>
                        <label className="col-md-12 form-control-label">{this.props.element.label ? this.props.element.label : ""}</label>
                        <div className="col-md-9 offset-3">
                            {this.props.element.childrens.map((radio, index) => (
                                <div className="radio" key={index}>
                                    <label htmlFor="radio1">
                                        <input type="radio" id="radio1" name="radios" value="option1" />{"  " + radio.text}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                );
                break;
            case 'CAMERA':
                return (
                    <div>
                        <button type="button" className="btn btn-primary"><i className="fa fa-camera"></i>{" " + "Cámara"}</button>
                    </div>
                );
                break;
            case 'CALENDAR':
                return (
                    <div>
                        <label>{this.props.element.label ? this.props.element.label : ""}</label>
                        <input
                            className="form-control"
                            value="DD/MM/AAAA"
                            style={{ width: "100%" }}
                            readOnly
                        />
                    </div >
                );
                break;
            case 'BARCODE':
                return (
                    <div>
                        <button type="button" className="btn btn-primary"><i className="fa fa-barcode"></i>{" " + "Código de barras"}</button>
                    </div>
                );
                break;
            case 'STORE':
                return (
                    <div style={{ textAlign: "justify" }}>
                        <label>{this.props.element.label ? this.props.element.label : ""}</label>
                        <select componentClass="select" placeholder="select" style={{ textAlign: "center" }}>
                            <option value="select">Seleccione tienda</option>
                            <option value="Tienda1">tienda 1</option>
                            <option value="Tienda2">tienda 2</option>
                            <option value="Tienda3">tienda 3</option>
                            <option value="other">...</option>
                        </select>
                    </div>
                );
            case 'DROPDOWNLIST':
                return (
                    <div style={{ textAlign: "justify" }}>
                        <label>{this.props.element.label ? this.props.element.label : ""}</label>
                        <select componentClass="select" placeholder="select" style={{ textAlign: "center" }}>
                            <option value="select">Drop Down</option>
                            <option value="Tienda1">opcion 1</option>
                            <option value="Tienda2">opcion 2</option>
                            <option value="Tienda3">opcion 3</option>
                            <option value="other">...</option>
                        </select>
                    </div>
                );
                break;
            case 'IMAGE':
                const contex = this;
                var storageRef = Firebase.storage().ref(this.props.element.value).getDownloadURL().then(function (url) {
                    document.getElementById("img").src = url;
                })
                switch (this.props.element.size) {
                    case "large":
                        return (
                            <div>
                                <img id="img" src={this.props.element.uri} width="50%" />
                            </div>
                        );
                    case "medium":
                        return (
                            <div>
                                <img id="img" src={this.props.element.uri} width="30%" />
                            </div>
                        );
                    case "small":
                        return (
                            <div>
                                <img id="img" src={this.props.element.uri} width="20%" />
                            </div>
                        );
                    default:
                        return (
                            <div>
                                <img id="img" src={this.props.element.uri} width="30%" />
                            </div>
                        )
                }
                break;
            case 'BUTTON':
                return (
                    <div>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            style={{
                                backgroundColor: this.props.element.style.backgroundColor, borderColor: this.props.element.backgroundColor, color: this.props.element.style.color
                            }}
                        >
                            {this.props.element.text}
                        </button>
                    </div>
                );
            case 'INPUT':
                return (
                    <div style={{ textAlign: "justify" }}>
                        <label>{this.props.element.label ? this.props.element.label : ""}</label>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <input type={this.props.element.type}
                                className="form-control"
                                value={this.props.element.value}
                                placeholder={this.props.element.placeholder}
                                onChange={(e) => this.setState({ value: e.target.value })}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                );
                break;
            case 'TITLE':
                return (
                    <div>
                        <h3>{this.props.element.text}</h3>
                    </div>
                );
                break;
            case 'LABEL':
                var type;
                switch (this.props.element.style.type) {
                    case 'bold':
                        return (
                            <div style={{ textAlign: "justify", color: this.props.element.style.color }}>
                                {this.props.element.style.size ?
                                    <this.props.element.style.size><b>{this.props.element.text}</b></this.props.element.style.size>
                                    :
                                    <b>{this.props.element.text}</b>
                                }

                            </div>
                        );
                        break;
                    case 'italic':
                        return (
                            <div style={{ textAlign: "justify", color: this.props.element.style.color }}>
                                {this.props.element.style.size ?
                                    <this.props.element.style.size><i>{this.props.element.text}</i></this.props.element.style.size>
                                    :
                                    <i>{this.props.element.text}</i>
                                }

                            </div>
                        );
                        break;
                    case 'default':
                        return (
                            <div style={{ textAlign: "justify", color: this.props.element.style.color }}>
                                {this.props.element.style.size ?
                                    <this.props.element.style.size><p>{this.props.element.text}</p></this.props.element.style.size>
                                    :
                                    <p>{this.props.element.text}</p>
                                }

                            </div>
                        );
                        break;
                    default:
                        return (
                            <div style={{ textAlign: "justify", color: this.props.element.style.color }}>
                                {this.props.element.style.size ?
                                    <this.props.element.style.size><p>{this.props.element.text}</p></this.props.element.style.size>
                                    :
                                    <p>{this.props.element.text}</p>
                                }

                            </div>
                        );
                }
            case 'CHECKBOX':
                return (
                    <div style={{ textAlign: "justify" }}>
                        <label>{this.props.element.text}</label>
                        <label className="float-right">
                            <input type="checkbox" style={{ position: "absolute", right: "10" }} checked={this.props.element.value} />
                        </label>
                    </div>
                );
                break;
            case 'SECTION':
                return (
                    <div className="card card-inverse" style={{ backgroundColor: this.props.element.style.backgroundColor, borderColor: this.props.element.backgroundColor, color: this.props.element.style.color, textAlign: "center" }} id="section">
                        <div className="card-block">
                            {this.props.element.text}
                        </div>
                    </div>
                );
            case 'BUTTONGROUP':
                return (
                    <div style={{ textAlign: "justify" }}>
                        <label className="form-control-label">{this.props.element.label ? this.props.element.label : ""}</label>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <div className="btn-group" role="group" aria-label="Basic example">
                                {this.props.element.childrens.map((button, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className="btn btn-secondary"
                                        style={{
                                            backgroundColor: button.style.backgroundColor, borderColor: button.backgroundColor, color: button.style.color
                                        }}
                                    >
                                        {button.text}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                );
                break;
            default:
                return (
                    <div>

                    </div>
                );
        }
    }
}

export default renderComponents;


// WEBPACK FOOTER //
// ./src/views/forms/renderComponents.js